/**
 * Mail aan de klant bij de briefing-check (Joris, 28 sep).
 *
 * Bron is alleen wat de engine aanlevert (`mail_klant`): de mail die door
 * `_mail_veilig` kwam, of — testronde okt — de vragen uit de navraaglijst die de
 * engine per vraag filterde op bedragen en interne info (`bron: 'navraaglijst'`).
 * De frontend filtert zelf niets uit de analyse (Codex r3). Pas als de engine niets
 * geeft, een lege opzet waarin de PL zelf de vragen schrijft. De bewerkbare preview
 * is de controle vóór versturen; dat is bewust. `notitie` zegt in de preview welke
 * vragen er bewust uit zijn (geld/budget) of dat de tekst uit de navraaglijst komt.
 * Onderwerp en ondertekening zetten we altijd zelf, zodat ze kloppen.
 */

export const LEGE_VRAGEN = '[Voeg hier je vragen toe]';

function notitieVoor(mailKlant) {
  const delen = [];
  if (mailKlant?.bron === 'navraaglijst') delen.push('De vragen komen uit de navraaglijst van de check — lees ze extra kritisch.');
  const n = Number(mailKlant?.weggelaten) || 0;
  if (n > 0) {
    delen.push(`${n === 1 ? 'Eén vraag' : `${n} vragen`} over geld of interne zaken (budget, prijs, offerte) ${n === 1 ? 'is' : 'zijn'} weggelaten — die stel je zelf, als dat nodig is.`);
  }
  return delen.join(' ') || null;
}

/** { onderwerp, tekst, vanEngine, notitie } — afzender = naam van de ingelogde gebruiker. */
export function maakKlantMail({ mailKlant, projectNaam, afzender, contactNaam } = {}) {
  const onderwerp = `Vragen over de briefing – ${projectNaam || 'het project'}`;
  const groet = `Met vriendelijke groet,\n\n${afzender || 'Full Frame'}`;
  const engineTekst = String(mailKlant?.tekst || '').trim();
  if (engineTekst) {
    // De engine eindigt op "Met vriendelijke groet," zonder naam; wij zetten die eronder.
    let romp = engineTekst.replace(/\n*\s*met vriendelijke groet,?\s*$/i, '').trim();
    // De navraaglijst-terugval kent de contactpersoon niet: aanhef hier aanvullen.
    const voornaamContact = String(contactNaam || '').trim().split(/\s+/)[0];
    if (mailKlant?.bron === 'navraaglijst' && voornaamContact) romp = romp.replace(/^Beste,/, `Beste ${voornaamContact},`);
    return { onderwerp, tekst: `${romp}\n\n${groet}`, vanEngine: true, notitie: notitieVoor(mailKlant) };
  }
  const voornaam = String(contactNaam || '').trim().split(/\s+/)[0];
  return {
    onderwerp,
    tekst: [`Beste${voornaam ? ` ${voornaam}` : ''},`, '', LEGE_VRAGEN, '', groet].join('\n'),
    vanEngine: false,
    notitie: null,
  };
}

/** mailto-link, alleen voor een geldig ogend adres. */
export function mailtoLink(email, mail) {
  const adres = String(email || '').trim();
  if (!mail || !/^[^\s@<>"]+@[^\s@<>"]+\.[^\s@<>"]+$/.test(adres)) return null;
  return `mailto:${adres}?subject=${encodeURIComponent(mail.onderwerp)}&body=${encodeURIComponent(mail.tekst)}`;
}

/**
 * Checks van vóór briefing-check v2 (28 sep) hebben geen vergelijking met offerte en
 * deliverables in de markdown. Dan zeggen we dat, met de weg erheen (Heranalyseer).
 */
export function mistVergelijking(markdown) {
  const md = String(markdown || '');
  if (!md.trim()) return false;
  return !/^\s*#{1,4}\s+afwijkingen\b/im.test(md);
}
